import { useCustomerAutoshipSubscriptions } from '@libs/common-next';

export const useAutoshipCustomerStatus = () => {
    const { autoshipData, isReady, isLoading, isFetching, isError } = useCustomerAutoshipSubscriptions();

    const customer = autoshipData?.data;

    const isExistingAutoshipCustomer = Boolean(customer?.hasAutoship);

    const isFirstAutoshipEligible = customer?.isFirstAutoshipEligible !== false;

    return {
        isError,
        isReady,
        isLoading,
        isFetching,
        isExistingAutoshipCustomer,
        isFirstAutoshipEligible,
    };
};
